import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import Typography from "Components/CommonComponents/Typography";
import { Spinner } from "reactstrap";
import "../index.css";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import RightArrow from "Assets/Icons/RightArrow";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
export interface ChapterListViewComponentInterface {
  chapterList: any[];
  isChapterListLoader: boolean;
  selectedChapter: any;
  setSelectedChapter: any;
  togglePane?: any;
  courseDetail?: any;
}
const ChapterListViewComponent = ({
  chapterList,
  isChapterListLoader,
  selectedChapter,
  setSelectedChapter,
  togglePane,
  courseDetail,
}: ChapterListViewComponentInterface) => {
  const { screen }: any = useWindowSize();
  const handleChapterClick = (ele: any) => {
    setSelectedChapter(ele);
    togglePane();
    const chapterSelectEvent = {
      event: "ag_planner_library_select_library_chapter",
      STREAM: courseDetail?.streamId ?? "",
      CLASS: courseDetail?.classId ?? "",
      SUBJECT: courseDetail?.subjectId ?? "",
      BOARD: courseDetail?.boardId ?? "",
      ACADEMIC_YEAR: courseDetail?.academicYearId ?? "",
      MEDIUM: courseDetail?.language ?? "",
    };
    console.log(
      "[GTM Track Event] ag_planner_library_select_library_chapter:",
      chapterSelectEvent
    );
    pushToDataLayerForGTM(chapterSelectEvent);
  };
  return (
    <>
      <div className="lecCol p-0">
        <Typography
          variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
          color="black"
        >
          Chapters List
        </Typography>
      </div>
      {isChapterListLoader ? (
        <div className="chapterListViewLoading">
          <Spinner color="info"></Spinner>
        </div>
      ) : (
        <>
          {chapterList.length == 0 ? (
            <div className="mt-4 mb-8">
              <NoResultFoundSearch
                primaryMessage="No chapters present"
                secondaryMessage={"We cannot found any chapters here"}
              >
                <NoDataFoundIcon />
              </NoResultFoundSearch>
            </div>
          ) : (
            <div
              className={
                ["xxl", "xl", "lg"].includes(screen)
                  ? "chapterListingMainDiv"
                  : "chapterListingMainDivMB"
              }
            >
              {chapterList.map((ele: any, index: number) => {
                return (
                  <div
                    key={index}
                    className={
                      selectedChapter != null &&
                      selectedChapter.sequence === ele.sequence
                        ? "chapterListDiv lecCol"
                        : "chapterListDivUnselected lecCol"
                    }
                    onClick={() => {
                      setSelectedChapter(ele);
                      togglePane();
                      handleChapterClick(ele);
                    }}
                  >
                    <div className="d-flex">
                      <Typography variant="subheading3" color="black">
                        {index + 1}
                      </Typography>
                      <span className="ml-2">
                        <Typography variant="subheading3" color="black">
                          {ele?.title}
                        </Typography>
                      </span>
                    </div>
                    <div>
                      <RightArrow />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </>
  );
};
export default ChapterListViewComponent;
